module.exports = __webpack_public_path__ + "img/Icon-edit.7d58ca60.svg";